import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { initialDataList } from '@interfaces/common/common.Interface'

export interface AuditState {
  auditList?: any
}

const initialState: AuditState = {
  auditList: initialDataList,
}

export const auditDucks = createSlice({
  name: 'audit',
  initialState,
  reducers: {
    getListAudit: (state: RootState, action: PayloadAction<any>) => {
      state.auditList = { loading: true, queryStr: action.payload }
    },
    getListAuditSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.auditList = { loading: false, ...action.payload }
    },
    getListAuditFail: (state: RootState, action: PayloadAction<any>) => {
      state.auditList = { loading: false, ...action.payload }
    },
    getAuditStats: (state: RootState, action: PayloadAction<any>) => {
      state.auditList = { loading: true, queryStr: action.payload }
    },
    getAuditStatsSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.auditList = { loading: false, ...action.payload }
    },
    getAuditStatsFail: (state: RootState, action: PayloadAction<any>) => {
      state.auditList = { loading: false, ...action.payload }
    },
    getAuditByEntity: (state: RootState, action: PayloadAction<any>) => {
      state.auditList = { loading: true, queryStr: action.payload }
    },
    getAuditByEntitySuccess: (state: RootState, action: PayloadAction<any>) => {
      state.auditList = { loading: false, ...action.payload }
    },
    getAuditByEntityFail: (state: RootState, action: PayloadAction<any>) => {
      state.auditList = { loading: false, ...action.payload }
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  getListAudit,
  getListAuditSuccess,
  getListAuditFail,
  getAuditStats,
  getAuditStatsSuccess,
  getAuditStatsFail,
  getAuditByEntity,
  getAuditByEntitySuccess,
  getAuditByEntityFail,
} = auditDucks.actions

export default auditDucks.reducer

